QueryHighlighter = {
        makeQueryRegex(search_string) {
                // escape meta characters
                search_string = search_string.replace(/([|()[{.+*?^$\\])/g, "\\$1");

                // split into words
                let words = search_string.split(/\s+/);

                // sort by length
                let length_comp = function(a, b) { 
                        return b.length - a.length;
                };   

                words.sort(length_comp);

                // replace characters by their compositors
                let accent_replacer = function(chr) {
                        return TextUtils.accentMap[TextUtils.unaccent(chr).toUpperCase()] || chr; 
                };   

                for (let i = 0; i < words.length; i++) {
                        words[i] = words[i].replace(/\S/g, accent_replacer);
                }    

                // join as alternatives
                let split = '(^|[^\\p{L}\\p{N}])(' + words.join("|") + ')'; 
                let match = '^(' + words.join("|") + ')$'; 

		return [
			new RegExp(split, 'gu'),
			new RegExp(match, 'gu'),
		];
        },   

        highlight(el, query, selector) {
                // cleanup any previous highlights
                QueryHighlighter.clear(el);

                if (!query) {
                        return;
                }

                // prepare regex for search query
                let [split, match] = QueryHighlighter.makeQueryRegex(query);

                function highlightTextNode(node, text, parentNode) {
			let frag = document.createDocumentFragment();

			let parts = text.split(split);
			if (parts.length > 1) {
				for (let p of parts) {
					if (p.match(match)) {
						let span = document.createElement('span');
						span.className = 'query-highlight';
						span.textContent = p;
						frag.appendChild(span);
					} else {
						frag.append(p);
					}
				}

				node.replaceWith(frag);
			}
                }

                function highlightEl(el) {
                        // we'll go recursively through all text nodes and check if we
                        // get a match, then we'll replace matching text nodes with
                        // a new content 'abcde' will become '<span class="query-highlight">abc</span>de'
                        // for search query 'abc'
                        el.normalize();

                        let n = el.firstChild, next;
                        while (n) {
                                next = n.nextSibling;

                                if (n.nodeType == 1) {
                                        highlightEl(n);
                                } else if (n.nodeType == 3) {
                                        let t = n.nodeValue;
                                        if (!t.match(/^\s*$/)) {
                                                highlightTextNode(n, t, el);
                                        }
                                }

                                n = next;
                        }
                }

                // create new highlights
		if (selector) {
			el.querySelectorAll(selector).forEach(highlightEl);
                } else {
                        highlightEl(el);
                }
        },

        clear(el) {
                for (let c of el.querySelectorAll('.query-highlight')) {
                        if (c.firstChild) {
                                c.replaceWith(c.firstChild);
                        }
                }
        }
};
